//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular, { IScope } from 'angular';

import { SessionVarsService } from '@services/session-vars-service';
import * as shareApi from '@share/api/shareApi';
import { IShareTaggedProductStats } from '@share/models/shareStateModel';
import template from './universal-image-actions-productize-sku-limits.html';

class UniversalImageActionsProductizeSkuLimits {
  public loading = true;
  public publisherName: string;
  public skuLimit;
  public taggedProducts: IShareTaggedProductStats[];
  public isModalOpen: boolean;

  private clientId: number;

  constructor(private $scope: IScope, sessionVarsService: SessionVarsService) {
    this.clientId = parseInt(sessionVarsService.getClientId(), 10);
  }

  public openCuModal() {
    this.isModalOpen = true;
  }

  public $onInit() {
    shareApi.getPublishersForCreator(this.clientId).then((response) => {
      // NOTE: Hard-coded expectations to 1 Publisher here because this is the max for the
      // NOTE: Share 2.0 MVP release with Target. By definition there will always be one
      // NOTE: Publisher, when we want to support more we'll need to bind in the Publisher
      // NOTE: client to benchmark against and check it here.
      if (response?.publisherClients?.length === 1) {
        const publisherClient = response.publisherClients[0];
        this.loading = false;
        this.publisherName = publisherClient.name;
        this.skuLimit = publisherClient.creatorBrandSkuLimit;

        shareApi
          .getTaggedProductsStats(publisherClient.id, this.clientId)
          .then((taggedProductsResponse) => {
            this.$scope.$applyAsync(() => {
              this.taggedProducts = taggedProductsResponse.taggedProducts;
            });
          });
      } else {
        this.loading = false;
      }
    });
  }
}

angular.module('uia').component('universalImageActionsProductizeSkuLimits', {
  template,
  controller: [
    '$scope',
    'SessionVarsService',
    UniversalImageActionsProductizeSkuLimits,
  ],
});
